import React from 'react';
import { Box, Barcode, AlertTriangle } from 'lucide-react';

export const InventoryModule: React.FC = () => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-slate-200 text-slate-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            ATstar & Asset Panda Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Assistive Device & Loaner Inventory</h2>
          <p className="text-xs text-slate-500">Wheelchair, hearing aid, and AAC hardware lending register and calibration alerts</p>
        </div>
      </div>

      <div className="space-y-3">
        <div className="p-3.5 bg-slate-50 border border-slate-200 rounded-xl flex items-center justify-between text-xs">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-slate-200 text-slate-800 rounded-lg flex items-center justify-center font-bold">
              <Box className="w-5 h-5" />
            </div>
            <div>
              <div className="font-bold text-slate-900">Tobii I-15 Eye-Gaze Speech Tablet</div>
              <div className="text-[10px] text-slate-500">SN: TD-2026-8891 | Loaned to: Master Amit K.</div>
            </div>
          </div>
          <span className="px-2 py-0.5 bg-emerald-100 text-emerald-800 text-[10px] font-bold rounded">On Active Loan</span>
        </div>

        <div className="p-3.5 bg-slate-50 border border-slate-200 rounded-xl flex items-center justify-between text-xs">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-slate-200 text-slate-800 rounded-lg flex items-center justify-center font-bold">
              <Box className="w-5 h-5" />
            </div>
            <div>
              <div className="font-bold text-slate-900">Oticon Medical Digital Hearing Aid Set</div>
              <div className="text-[10px] text-slate-500">SN: HA-2026-3021 | Maintenance Calibration Due</div>
            </div>
          </div>
          <span className="px-2 py-0.5 bg-amber-100 text-amber-800 text-[10px] font-bold rounded flex items-center gap-1">
            <AlertTriangle className="w-3 h-3" /> Calibration Alert
          </span>
        </div>
      </div>
    </div>
  );
};
